import {invalidateQueries, q} from "../../../state";
import {
  ComplexityAttributeId,
  ComplexityModelId,
  ComplexityModelVersionId,
  CreateComplexityAttribute,
  UpdateComplexityAttribute,
} from "platformed-client/types";
import {platformedClient} from "../..";

/**
 * Create a new attribute for a complexity model version
 */
export async function create(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  attribute: CreateComplexityAttribute,
): Promise<ComplexityAttributeId> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/attribute",
    {path: {model_id: modelId, version_id: versionId}, body: attribute},
  );
  await invalidateQueries([
    q.tprm.complexityModels.filter(),
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityModelVersionExport.filter(modelId, versionId),
  ]);
  return res;
}

/**
 * Update an existing complexity attribute
 */
export async function update(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  attributeId: ComplexityAttributeId,
  update: UpdateComplexityAttribute,
) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/attribute/{attribute_id}",
    {path: {model_id: modelId, version_id: versionId, attribute_id: attributeId}, body: update},
  );
  await invalidateQueries([
    q.tprm.complexityModels.filter(),
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityModelVersionExport.filter(modelId, versionId),
  ]);
  return res;
}

/**
 * Delete a complexity attribute
 */
export async function delete_(
  modelId: ComplexityModelId,
  versionId: ComplexityModelVersionId,
  attributeId: ComplexityAttributeId,
) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/complexity/{model_id}/version/{version_id}/attribute/{attribute_id}",
    {path: {model_id: modelId, version_id: versionId, attribute_id: attributeId}},
  );
  await invalidateQueries([
    q.tprm.complexityModels.filter(),
    q.tprm.complexityModel.filter(modelId),
    q.tprm.complexityModelVersions.filter(modelId),
    q.tprm.complexityModelVersion.filter(modelId, versionId),
    q.tprm.complexityModelVersionExport.filter(modelId, versionId),
  ]);
  return res;
}
